import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, Phone, MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP } from "./hcaData";

export const HcaLeadSuccess = ({ lead }) => (
    <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center py-6"
        data-testid="hca-lead-success"
    >
        <CheckCircle2 className="h-14 w-14 text-[#2E6F40] mx-auto" />
        <h3 className="font-display text-2xl text-[#0E1E3A] mt-4">Thank you, {lead.name.split(" ")[0]}!</h3>
        <p className="text-sm text-[#5E6B7E] mt-2 leading-relaxed">
            An admissions advisor will call you{" "}
            <strong className="text-[#0E1E3A]">{lead.best_time_to_call.split(" (")[0].toLowerCase()}</strong> at{" "}
            <strong className="text-[#0E1E3A]" data-testid="hca-lead-success-phone">{lead.phone}</strong>.
        </p>
        <p className="text-xs text-[#5E6B7E] mt-6 uppercase tracking-[0.18em]">Can't wait?</p>
        <div className="mt-3 flex flex-col sm:flex-row gap-2 justify-center">
            <a href={PHONE_TEL} data-testid="hca-success-call-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-[#0E1E3A] px-4 py-2 text-sm text-[#0E1E3A] hover:bg-[#0E1E3A] hover:text-white transition-colors">
                <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
            </a>
            <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="hca-success-whatsapp-link" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2E6F40] px-4 py-2 text-sm text-white hover:bg-[#245733] transition-colors">
                <MessageCircle className="h-4 w-4" /> WhatsApp us
            </a>
        </div>
    </motion.div>
);
